export const siteData = {
  brand: "BIGGIE POPPINS",
  monogram: "BP",
  eyebrow: "Working home base",
  tagline: "Builder working across AI, systems, media, and commerce.",
  intro:
    "A home base for selected work, ideas in progress, and the things holding my attention right now.",
  ctas: {
    primary: { label: "See current work", href: "#portfolio" },
    secondary: { label: "Find me on Instagram", href: "https://instagram.com/BiggiePoppins" }
  },
  socials: [
    { name: "X", url: "https://x.com/BiggiePoppins", icon: "Twitter" },
    { name: "Instagram", url: "https://instagram.com/BiggiePoppins", icon: "Instagram" },
    { name: "GitHub", url: "https://github.com/gueysito", icon: "Github" }
  ],
  signalStrip: ["AI / automation", "commerce", "creative systems", "selected writing"],
  about: {
    title: "QUIET SIGNAL, REAL WORK",
    paragraphs: [
      "I like tools that sharpen judgment, brands with staying power, and systems that make good work easier to repeat.",
      "This site is intentionally lean. No fake case studies. No inflated claims. Just a cleaner picture of what I’m building, what I care about, and where my head is at."
    ],
    lab: {
      label: "Crafty Systems Labs",
      href: "https://github.com/Crafty-Systems-Labs",
      body:
        "A lot of my market-facing product work ships through Crafty Systems Labs — the lab where I build, test, and refine ideas that are better shown through products than talked about in abstractions."
    },
    principles: [
      {
        title: "Taste over noise",
        body: "If it feels hollow, trendy, or overbuilt, it probably gets cut."
      },
      {
        title: "Systems that compound",
        body: "I care about work that gets more valuable as the reps stack."
      },
      {
        title: "Built in public, selectively",
        body: "Enough signal to show the direction. Not enough leakage to hand over the blueprint."
      }
    ]
  },
  portfolio: [
    {
      id: 1,
      title: "Time Capsule",
      description:
        "An email-first reflection product designed to make memory more useful over time. Part journaling ritual, part personal context engine — built to turn scattered self-knowledge into something sharper and more usable.",
      category: "Product",
      status: "Shaping",
      tags: ["memory", "email", "AI context"]
    },
    {
      id: 2,
      title: "Ronin / MatMentor",
      description:
        "A sharper training companion for Brazilian Jiu-Jitsu. Built around the real texture of getting better on the mat — not generic motivation, but tighter feedback, pattern recognition, and smarter reps.",
      category: "Systems",
      status: "Active",
      tags: ["BJJ", "coaching", "feedback loops"]
    },
    {
      id: 3,
      title: "On Special",
      description:
        "A market-facing product built through Crafty Systems Labs for operators who need more from their promotions than generic posting. The focus is clearer positioning, tighter execution, and better leverage at the local business layer.",
      category: "Commerce",
      status: "Building",
      tags: ["local business", "promotions", "workflow"]
    }
  ],
  blog: [
    {
      id: 1,
      title: "What AI is actually good for in a small operation",
      excerpt:
        "Not replacing judgment. Compressing busywork, tightening loops, and giving yourself better leverage.",
      category: "Notes in progress"
    },
    {
      id: 2,
      title: "Brands people return to versus brands they scroll past",
      excerpt:
        "Ritual, identity, timing, and why most offers feel interchangeable long before they fail.",
      category: "Notes in progress"
    },
    {
      id: 3,
      title: "Decision-making when the information is incomplete",
      excerpt:
        "How to move with enough conviction to learn, but not so much ego that you ignore the market.",
      category: "Notes in progress"
    }
  ],
  contact: {
    title: "BEST PLACE TO FIND ME",
    blurb:
      "Instagram and X are the quickest live channels. GitHub is where the public code trail lives. Crafty Systems Labs is where a lot of the market-facing product work gets shipped.",
    availability: [
      "Interesting product and systems conversations",
      "Brand direction with actual commercial intent",
      "Select collaborations where the taste bar is high"
    ]
  }
};
